module.exports = __webpack_public_path__ + "product-compound-capsule-02.jpg?a51fac340d4ad50783be6c985e516996";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-compound-capsule-02.jpg
// module id = 99
// module chunks = 0